import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useRemove = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback((id: string) => dispatch({ type: 'REMOVE_SEND_EMAIL_MESSAGE', payload: { id } }), [dispatch]);
};
